import { CheckCircle, Error, HourglassTop, Sync } from "@mui/icons-material";
import { AutomationStatus } from "@pages/OrderTracker/components/PlanningAutomation/utils";

const AutomationStatusIcon = ({
  status,
  fontSize = "inherit",
}: {
  status: AutomationStatus;
  fontSize?: string;
}): JSX.Element => {
  switch (status) {
    case AutomationStatus.SUCCESS:
      return <CheckCircle color="success" sx={{ fontSize }} />;
    case AutomationStatus.NOT_STARTED:
      return <HourglassTop color="disabled" sx={{ fontSize }} />;
    case AutomationStatus.IN_PROGRESS:
      return <Sync color="secondary" sx={{ fontSize }} />;
    case AutomationStatus.ERROR:
      return <Error color="error" sx={{ fontSize }} />;
    default:
      return <></>;
  }
};
export default AutomationStatusIcon;
